module.exports = __webpack_public_path__ + "img/share_url_icon.c67b4a86.svg";